import { FC } from 'react';
import { Controller, FieldError, get, useFormContext } from 'react-hook-form';

import moment, { Moment } from 'moment';

import { renderRequiredLabel } from '@/components/FormElements/RequiredFieldLabel';
import { DATE_TIME_FORMAT } from '@/config';

import { DateTimePicker } from '../DateTimePicker';
import { DatePickersFormFieldProps } from '../FormDateField';

export const FormDateTimeField: FC<DatePickersFormFieldProps> = (props) => {
  const {
    name,
    rules,
    defaultValue,
    label,
    format = DATE_TIME_FORMAT,
    handleChange,
    handleAccept,
    ...rest
  } = props;

  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name) as FieldError;
  const isRequired = !!rules?.required;

  return (
    <Controller
      control={control}
      defaultValue={Boolean(defaultValue) || ''}
      name={name}
      render={({ field: { onBlur, onChange, ...restField } }: any) => (
        <DateTimePicker
          {...rest}
          {...restField}
          error={error?.message}
          label={renderRequiredLabel(label, isRequired)}
          format={format}
          value={moment(restField.value)}
          onAccept={(value: Moment) => {
            if (handleAccept != null)
              handleAccept(name, moment(value).format(format));
            if (handleChange != null)
              handleChange(name, moment(value).format(format));
            onChange(value?.format(format));
          }}
          onClear={() => {
            if (handleChange != null) handleChange(name, '');
            if (handleAccept != null) handleAccept(name, '');
            onChange('');
          }}
          onBlur={onBlur}
        />
      )}
      rules={rules}
    />
  );
};
